import { EyeOutlined, InfoCircleOutlined, UserAddOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import employeeService from "Services/AdminServices/Organization/EmployeeService";
import { useNavigate } from "react-router-dom";

export const useEmployee = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [employeeDetail, setEmployeeDetail] = useState(null);
  const [compensations, setCompensations] = useState([]);
  const [loadingCompensation, setLoadingCompensation] = useState(false);
  const [compensationsLoaded, setCompensationsLoaded] = useState(false);
  const [employments, setEmployments] = useState([]);
  const [loadingEemployments, setLoadingEmployments] = useState(false);
  const [employmentsLoaded, setEmploymentsLoaded] = useState(false);
  const [directReports, setDirectReports] = useState([]);
  const [loadingDirectReports, setLoadingdDrectReports] = useState(false);
  const [directReportsLoaded, setDirectReportssLoaded] = useState(false);
  const [ careerPaths, setCareerPaths ] = useState([]);
  const [ loadingCareerPaths, setLoadingCareerPaths] = useState(false);
  const [ careerPathsLoaded , setCareerPathsLoaded] = useState(false);
  const navigate = useNavigate();

  const fetchEmployees = async () => {
    try {
      setLoading(true);

      const data = await employeeService.getEmployees(null,null);
      console.log("employees", data);
      setEmployees(data);
    } catch (error) {
      console.error("Error in fetching employees", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployeeDetail = async (employeeId) => {
    try {
      setLoadingDetail(true);
      const data = await employeeService.getEmployeeDetail(employeeId);
      setEmployeeDetail(data);
    } catch (error) {
      console.error(" Error in geting employee detail", error);
    } finally {
      setLoadingDetail(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const resetEmployeeTabs = () => {
  setCompensations([]);
  setEmployments([]);
  setDirectReports([]);

  setCompensationsLoaded(false);
  setEmploymentsLoaded(false);
  setDirectReportssLoaded(false);
};

  const fetchCompensations = async (employeeId) => {
    try {
      setLoadingCompensation(true);
      const data = await employeeService.getCompensations(employeeId);
      setCompensations(data);
      setCompensationsLoaded(true);
    } catch (error) {
      console.error(" Error in geting compensations detail", error);
    } finally {
      setLoadingCompensation(false);
    }
  };

  const fetchEmployments = async (employeeId) => {
    try {
      setLoadingEmployments(true);
      const data = await employeeService.getEmployement(employeeId);
      setEmployments(data);
      setEmploymentsLoaded(true);
    } catch (error) {
      console.error(" Error in geting Employments detail", error);
    } finally {
      setLoadingEmployments(false);
    }
  };

  const fetchDirectReports = async (employeeId) => {
    try {
      setLoadingdDrectReports(true);

      const data = await employeeService.getDirectReports(employeeId);

      setDirectReports(data);
      setDirectReportssLoaded(true);
    } catch (error) {
      console.error("Error in getting direct reports", error);
    } finally {
      setLoadingdDrectReports(false);
    }
  };

  const fetchCareerPaths = async (employeeId) => {
    try {
      setLoadingCareerPaths(true);

      const data = await employeeService.getCareerPaths(employeeId);
console.log("career", data);
      setCareerPaths(data);
      setCareerPathsLoaded(true);
    } catch (error) {
      console.error("Error in fetching career paths", error);
    } finally {
      setLoadingCareerPaths(false);
    }
  };

  const columns = [
    {
      title: "Employee",
      dataIndex: "employee",
      key: "employee",
     render: (_, record) => (
  <div>
    <div style={{ fontWeight: "bold", display: "flex", alignItems: "center", gap: 6 }}>
      {record.fullName}

      {record.isOrphan && (
        <Tooltip title="This employee has been invited but hasn't completed registration yet">
          <span
            style={{
              background: "#faad14",
              color: "white",
              fontSize: "11px",
              padding: "2px 6px",
              borderRadius: "6px",
              cursor: "help",
              display: "flex",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <InfoCircleOutlined style={{ fontSize: "10px" }} />
            Invited
          </span>
        </Tooltip>
      )}
    </div>

    <div style={{ color: "#888" }}>
      {record.publicId} - {record.email}
    </div>
  </div>
)
    },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
    },
    {
      title: "Job Title/Department",
      dataIndex: "jobTitleName",
      key: "jobTitleName",
      render: (_, record) => {
        if (!record.departmentName) {
          return <div style={{ fontWeight: "bold" }}>Org-Wide Role</div>;
        }

        return (
          <div>
            <div style={{ fontWeight: "bold" }}>{record.jobTitleName ?? "Null"}</div>
            <div style={{ color: "#888" }}>{record.departmentName ?? "Null"}</div>
          </div>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (value) =>
        value
          ? new Date(value).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "Null",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            icon={<EyeOutlined />}
            onClick={() => navigate(`/employeeDetail/${record.id}`)}
          />
          
          {record.isOrphan && (
            <Tooltip title="Fill personal information for this invited employee">
              <Button
                type="primary"
                icon={<UserAddOutlined />}
                onClick={() => navigate(`/humanResourceInvited/${record.id}`)}
                style={{ backgroundColor: "#599c16", borderColor: "#599c16" }}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return {
    loading,
    employees,
    columns,

    employeeDetail,
    loadingDetail,
    fetchEmployeeDetail,

    compensations,
    loadingCompensation,
    fetchCompensations,
    compensationsLoaded,

    employments,
    loadingEemployments,
    employmentsLoaded,
    fetchEmployments,

    directReports,
    loadingDirectReports,
    directReportsLoaded,
    fetchDirectReports,

    careerPaths,
    loadingCareerPaths,
    careerPathsLoaded,
    fetchCareerPaths,

    resetEmployeeTabs
  };
};